import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { VueHammer } from "vue2-hammer";

Vue.use(VueHammer);
VueHammer.config.pinch = {
  enable: true
};
VueHammer.config.tap = {
  taps: 2
};
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});
